@if (accomodatedModels().length) {
  <div
    class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm text-primary-500 px-4 py-5 sm:px-6 sm:py-6"
  >
    <app-listing-details-accordion accordionId="will-accommodate" title="Available Floor Plans">
      <div class="grid grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
        @for (model of accomodatedModels(); track $index) {
          <app-model-card [model]="model" />
        }
      </div>
    </app-listing-details-accordion>
  </div>
}
